module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-11.c449ff99.png";